import React from "react";
import "./DriverLogInspectionReportsView.css";
import {
  Typography,
  TableContainer,
  Box,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Theme,
} from "@material-ui/core";
import { useTranslate, FunctionField } from "react-admin";
import { format } from "date-fns";
import { ArrayField } from "../../../common/data-grid-fields/ArrayField";
import IndeterminateCheckBoxIcon from "@material-ui/icons/IndeterminateCheckBox";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import { useTheme } from "@material-ui/styles";

interface DriverLogInspectionReportsViewProps {
  record: any;
}

export const DriverLogInspectionReportsView = ({
  record,
}: DriverLogInspectionReportsViewProps) => {
  const theme: Theme = useTheme();
  const translate = useTranslate();
  return (
    <div id="driver-log-inspection-report-container">
      <Typography variant="h6">
        {translate("resources.hos-driver-log-view.labels.inspectionReports")}
      </Typography>
      <TableContainer component={Box}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>
                {translate("resources.hos-driver-log-view.labels.dateTime")}
              </TableCell>
              <TableCell>
                {translate("resources.hos-driver-log-view.labels.vehicle")}
              </TableCell>
              <TableCell>
                {translate("resources.hos-driver-log-view.labels.odometer")}
              </TableCell>
              <TableCell>
                {translate("resources.hos-driver-log-view.labels.defects")}
              </TableCell>
              <TableCell className="centered-content">
                {translate("resources.hos-driver-log-view.labels.signed")}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {record.inspectionReports &&
              record.inspectionReports.map((report: any) => (
                <TableRow key={report.id}>
                  <TableCell>
                    {report.time && format(report.time, "MMM do, p")}
                  </TableCell>
                  <TableCell>{report.vehicleName}</TableCell>
                  <TableCell>{report.odometer}</TableCell>
                  <TableCell>
                    <ArrayField
                      record={report}
                      source="defects"
                      displayedElementsCount={2}
                      emptyArrayDisplay={translate(
                        "resources.hos-driver-log-view.labels.noDefects"
                      )}
                    />
                  </TableCell>
                  <TableCell>
                    <FunctionField<any>
                      record={report}
                      render={(record: any) => (
                        <Box className="centered-content">
                          {record?.signed ? (
                            <CheckBoxIcon
                              style={{
                                color: theme.palette.success.main,
                              }}
                            />
                          ) : (
                            <IndeterminateCheckBoxIcon
                              style={{
                                color: theme.palette.error.main,
                              }}
                            />
                          )}
                        </Box>
                      )}
                    />
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};
